export const RELEASE_TYPE = {
  ENHANCEMENT: { value: 1, text: "機能改善", color: "#4CAF4F" },
  FEATURE: { value: 2, text: "新機能", color: "#ffba40" },
  BUG_FIX: { value: 3, text: "不具合改修", color: "#f58e7d" },
} as const;

export const PAGE = {
  HOME: { value: 1, text: "Home" },
  ANALYTICS: { value: 2, text: "Analytics" },
  ADUNIT_GROUP: { value: 3, text: "Adunit Group" },
  WRAPPER: { value: 4, text: "Wrapper" },
  ID_MANAGER: { value: 5, text: "ID Manager" },
  ENGAGEMENT: { value: 6, text: "Engagement" },
  LAYOUT: { value: 7, text: "Layout" },
  CORE_WEB_VITALS: { value: 8, text: "Core Web Vitals" },
  RELEASE_NOTE: { value: 9, text: "Release Note" },
  HELP_CENTER: { value: 10, text: "Help Center" },
  SETTING: { value: 11, text: "Setting" },
} as const;
